<template>
  <div class="view-funding-detail">
    <InvestorsPageContent :investor="investor" @claim="claim" @apply="apply" />

    <FundingPitchModal
      v-model="isApplyOpen"
      :investor="investor"
      @submitted="onSubmitted"
    />
    <FundingClaimModal
      v-model="isClaimOpen"
      :investor="investor"
      @submitted="onClaimSubmitted"
    />

    <ApplicationSentModal
      v-model="isApplicationSent"
      :success-data="successData"
    />
  </div>
</template>

<script>
import InvestorsPageContent from '@/components/investors/InvestorsPageContent'
import FundingPitchModal from '@/modals/funding/FundingPitch'
import ApplicationSentModal from '@/modals/ApplicationSent'
import FundingClaimModal from '@/modals/funding/FundingClaim'
import { buildMetaHead } from '@/helpers/meta'

export default {
  name: 'PageFundingId',
  components: {
    InvestorsPageContent,
    FundingPitchModal,
    FundingClaimModal,
    ApplicationSentModal
  },
  data() {
    return {
      isApplyOpen: false,
      isApplicationSent: false,
      isClaimOpen: false,
      successData: null
    }
  },
  computed: {
    investor() {
      return this.$store.state.investors.investor
    }
  },
  asyncData({ params, store, error }) {
    try {
      return store.dispatch('investors/get', params.id)
    } catch (err) {
      error(err)
    }
  },
  head() {
    return buildMetaHead({
      title: 'Funding | ' + this.investor.name,
      description: this.investor.intro
        .replace(/(<([^>]+)>)/gi, ' ')
        .substr(0, 255)
        .trim(),
      path: this.$route.path
    })
  },
  methods: {
    onSubmitted() {
      this.isApplyOpen = false
      this.successData = {
        title: 'Pitch sent!',
        subtitle: 'We notified the investor about your pitch',
        image: 'paper-plane.svg',
        link: '/funding',
        label: 'Browse more investors',
        width: '447'
      }
      this.isApplicationSent = true

      this.$gtm.push({ event: 'fb', fbEvent: 'PitchSubmit' })
      this.$gtm.push({
        event: 'ga.event',
        category: 'form',
        action: 'PitchSubmit',
        label: this.$route.params.id
      })

      this.$gtm.push({
        event: 'ga.event',
        category: 'investor',
        action: 'InvestorPitchSubmit'
      })

      this.$engagement({
        type: 'investor.pitchSubmit'
      })
    },
    apply() {
      this.isApplyOpen = true

      this.$gtm.push({
        event: 'ga.event',
        category: 'investor',
        action: 'InvestorPitchClick'
      })

      this.$engagement({
        type: 'investor.pitchClick'
      })
    },
    claim() {
      this.isClaimOpen = true

      this.$gtm.push({
        event: 'ga.event',
        category: 'investor',
        action: 'InvestorClaimClick'
      })

      this.$engagement({
        type: 'investor.claimClick'
      })
    },
    onClaimSubmitted() {
      this.isClaimOpen = false
      this.successData = {
        title: 'Your request is sent!',
        subtitle:
          'Thank you for your request to claim your investor profile. You will be informed via e-mail when we’ve approved your request or whenever  we have additional questions. The reviewing process normally takes 1-2 business days.',
        image: 'paper-plane.svg',
        label: 'Close',
        width: '447'
      }
      this.isApplicationSent = true

      this.$gtm.push({
        event: 'ga.event',
        category: 'investor',
        action: 'InvestorClaimSubmit'
      })

      this.$engagement({
        type: 'investor.claimSubmit'
      })
    }
  }
}
</script>
